import React from 'react';
import VideoList from '../../components/StudentPortal/CoursePlayer/VideoList';

const Home = () => {
    return (
        <section className="py-6 bg-primary">
      <div className="mx-auto max-w-7xl px-5 lg:px-0">
        <div className="grid grid-cols-3 gap-2 lg:gap-8">
          <div className="col-span-full w-full space-y-8 lg:col-span-2">
           <h3 className='text-3xl text-center font-extrabold'>Select Lesson</h3>
           <VideoList />
          </div>
          
        </div>
      </div>
    </section>
    );
};

export default Home;